import { NgModule } from '@angular/core';

import { ConfigurationsRoutingModule } from './configurations-routing.module';
import { CONFIGURATIONS_STATES } from './configurations.states';
import { UIRouterModule } from '@uirouter/angular';
import { TrainTypeConfigurationComponent } from './containers/train-type-configuration/train-type-configuration.component';
import { ProjectConfigurationComponent } from './containers/project-configuration/project-configuration.component';
import { SharedModule } from '../../shared/shared.module';
import { JsonConfigurationManagementComponent } from './components/json-configuration-management/json-configuration-management.component';
import { ProjectCreateComponent } from './components/project-create/project-create.component';
import { TrainTypeCreateComponent } from './components/train-type-create/train-type-create.component';


@NgModule({
  declarations: [TrainTypeConfigurationComponent, ProjectConfigurationComponent, JsonConfigurationManagementComponent, ProjectCreateComponent, TrainTypeCreateComponent],
  imports: [
    SharedModule,
    ConfigurationsRoutingModule,
    UIRouterModule.forChild({ states: [...CONFIGURATIONS_STATES] })
  ]
})
export class ConfigurationsModule { }
